
/**
 * Keep enum instead of boolean to better differenciate null vs enum value
 */
export enum SignInAuthenticated {
    TRUE = "true",
    FALSE = "false",
}